import { render, staticRenderFns } from "./DubunSvg.vue?vue&type=template&id=859b4246&scoped=true"
import script from "./DubunSvg.vue?vue&type=script&lang=js"
export * from "./DubunSvg.vue?vue&type=script&lang=js"
import style0 from "./DubunSvg.vue?vue&type=style&index=0&id=859b4246&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859b4246",
  null
  
)

export default component.exports